'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var conditionClassModifier = function conditionClassModifier(condition) {
  return condition && condition.toLowerCase().replace(/_/g, '-');
};

exports.default = conditionClassModifier;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/helpers/conditionClassModifier.js
// module id = 185
// module chunks = 0